module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "select-container clearfix",
    staticStyle: {
      "margin-top": "2%",
      "margin-left": "2%",
      "float": "left"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "30px",
      "font-weight": "bold"
    }
  }, [_vm._v("MOA客户端未安装")]), _c('br'), _c('br'), _vm._v(" "), _c('p', [_vm._v("打开浏览器，复制粘贴如下URL：")]), _vm._v(" "), _c('p', [_vm._v("https://report-mon.sankuai.com/report/api/check_status?mis_id=pengzhengmao")]), _vm._v(" "), _c('p', [_c('img', {
    attrs: {
      "src": require("../../assets/verifyMoaIsInstall/verifyMoaIsInstall_pic01.png"),
      "width": "1040px",
      "height": "100px"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("将“pengzhengmao” 更换为自己的MIS账号，“MOA”：“Y” 则表示该MIS号已正常安装MOA。")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4a9c1373!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/moaUninstallURL/verifyMoaIsInstall.vue
// module id = 645
// module chunks = 1